import {createOsmContent} from '@/lib/classes/InfoWindowContent';
import type {MapLayer} from '@/services/GraphicService/MapLayer';
import type {Event, VectorTileGraphic} from '@/services/GraphicService/VectorTileGraphic/VectorTileGraphic';

/**
 * Handles click events occurring on an OSM layer.
 * @param event An event object containing information about the click event.
 * @param layer The name of the OSM layer that was clicked.
 */
const handleOsmLayerClick = (event: Event, layer: MapLayer, graphic: VectorTileGraphic) => {
  return event.features.map((feature) => ({content: createOsmContent(layer.id, feature.object.properties, graphic)}));
};

export {
  handleOsmLayerClick,
};
